import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { PwSacDto } from '../../models/pw-sac.dto';
import { PWSacResponseDto } from '../../models/pw-sac-response.dto';

@Injectable({
  providedIn: 'root'
})
export class PwSacService {

  private readonly path = '/pw';
    
      constructor(private http: HttpClient) {}
    
      create(pwSacDto: PwSacDto): Observable<PWSacResponseDto> {
        return this.http.post<PWSacResponseDto>(`${environment.apiBaseUrl}${this.path}`, pwSacDto);
      }
  
}
